import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { motion } from 'framer-motion';
import i18n from 'i18next';
import PlayCircleOutline from '@mui/icons-material/PlayCircleOutline';

import { Typo } from 'uikit/content';
import { Button } from 'uikit/buttons';

import getCoverArtUrl from '../helpers/getCoverArtUrl';

import VideoCoverArt from './videoCoverArt';

import styles from '../styles/videoPlayerNextUp.module.scss';

const VideoPlayerNextUp = ({ item, handleRemovePopup }) => {
  const [countdown, setCountdown] = useState(8);

  const history = useHistory();

  const handleNavigateVideo = () => {
    handleRemovePopup();
    history.push(`/student/videos/on-demand/${item.id}`);
  };

  useEffect(() => {
    if (countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);

      return () => {
        clearInterval(timer);
      };
    }
    handleNavigateVideo();
  }, [countdown]);

  return (
    <motion.div
      className={styles.container}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className={styles.inner}>
        <VideoCoverArt picture={getCoverArtUrl(item.cover_art)} duration={item.duration} />
        <div className={styles.content}>
          <Typo color="secondary" className={styles.upNext} variant="s02">
            {i18n.t('up-next-in')} {countdown}
          </Typo>
          <Typo className={styles.title} variant="d01">
            {item.name}
          </Typo>
          <Button
            className={styles.playNow}
            color="brand"
            text={i18n.t('play-now')}
            icon={<PlayCircleOutline />}
            onClick={handleNavigateVideo}
          />
          <Button variant="ghost" text={i18n.t('cancel')} onClick={handleRemovePopup} />
        </div>
      </div>
    </motion.div>
  );
};

export default VideoPlayerNextUp;
